import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl';
  const variants = {
    primary: 'bg-brand-green text-white hover:bg-[#007036]',
    secondary: 'bg-brand-red text-white hover:bg-[#A81B22]',
    outline: 'bg-transparent border-2 border-brand-green text-brand-green hover:bg-brand-green hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-50">
        {children}
        <ChevronRight className="ml-2 w-5 h-5" data-id="element-51" />
      </a>;
  }
  return <button className={classes} {...props} data-id="element-52">
      {children}
      <ChevronRight className="ml-2 w-5 h-5" data-id="element-53" />
    </button>;
}